import React from "react";

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ 
  fullScreen = true, 
  text = "Chargement..." 
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-3 text-center">
      <div className="relative h-16 w-16">
        {/* Bordure tournante */}
        <div className="absolute inset-0 rounded-full border-4 border-t-primary border-gray-200 animate-spin"></div>
        {/* Favicon fixe */}
        <img
          src="/assets/logo/favicon.jpeg"
          alt="Afflucoin"
          className="h-10 w-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"
        />
      </div>
      <p className="text-gray-600 font-medium">{text}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
        {content}
      </div>
    );
  }

  return <div className="py-6">{content}</div>;
};

export default Loading;
